import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "/Users/dream/Desktop/work/project/jihuiduo-member-h5/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.sort";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/dream/Desktop/work/project/jihuiduo-member-h5/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/Users/dream/Desktop/work/project/jihuiduo-member-h5/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import gprice from "../../components/gprice";
import { mapState } from 'vuex';
import Gprice from "../../components/gprice.vue";
export default {
  name: '',
  components: {
    gprice: gprice
  },
  props: {
    type: {
      type: String,
      default: "shop"
    },
    // mainImg: {
    //   type: String,
    //   default: ""
    // },
    saleSkuQuantity: {
      type: Number,
      default: 0
    },
    buyStatus: {
      type: Boolean,
      default: false
    },
    initNum: {
      type: Number,
      default: 0
    },
    isShop: {
      type: Boolean,
      default: true
    },
    spuAttrs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    packAttr: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    skuAttrs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isitemPintuanInfoVo: {
      type: Boolean,
      default: false
    },
    defaultId: {
      type: Number,
      default: 0
    },
    goodsDetail: {
      type: Object,
      function: function _function() {
        return {};
      }
    },
    changeDisabled: {
      type: Boolean,
      default: false
    },
    newPrice: {
      type: String | Number,
      default: 0
    },
    isNewer: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    isLogin: function isLogin(state) {
      return state.user.isLogin;
    }
  })), {}, {
    selectAttr: function selectAttr() {
      var emptyAttr = [];
      this.spuData.forEach(function (spu) {
        spu.attributeValues.forEach(function (attr) {
          if (attr.active) {
            emptyAttr.push(attr.saleAttributeValue);
          }
        });
      });
      return emptyAttr.join(" ");
    },
    selectId: function selectId() {
      var emptyAttr = [];
      this.spuData.forEach(function (spu) {
        spu.attributeValues.forEach(function (attr) {
          if (attr.active) {
            emptyAttr.push(attr.saleAttributeValueId);
          }
        });
      });
      return emptyAttr;
    }
  }),
  data: function data() {
    return {
      title: '',
      spuData: [],
      selectAttrId: "",
      payNum: 1,
      isadd: false,
      isoff: false
    };
  },
  watch: {
    "saleSkuQuantity": function saleSkuQuantity(newval) {
      if (this.payNum > newval) {
        this.payNum = newval;
      }
    }
  },
  mounted: function mounted() {
    this.spuData = JSON.parse(JSON.stringify(this.spuAttrs)); // this.setDefault()

    this.payNum = this.initNum;
  },
  methods: {
    okBtn: function okBtn() {
      var _this = this;

      if (!this.buyStatus || !this.saleSkuQuantity || this.isoff) {
        return;
      }

      this.$store.dispatch("user/checkLogin").then(function (res) {
        if (!_this.isLogin) {
          if (_this.$platform === "miniProgram") {
            var fullPath = _this.$route.fullPath;
            var path = "/pages/detail/detail";

            _this.$wx.miniProgram.redirectTo({
              url: "/pages/login/login?pagefrom=" + path + "&" + fullPath.split('?')[1]
            });
          } else {
            _this.$router.push({
              path: "/login"
            });
          }

          return;
        }
      }); // if(!this.isLogin){
      //   if(this.$platform === "miniProgram"){
      //     let fullPath = this.$route.fullPath;
      //     let path = `/pages/detail/detail`
      //     this.$wx.miniProgram.redirectTo({
      //       url: "/pages/login/login?pagefrom="+path+"&"+fullPath.split('?')[1]
      //     })
      //   }else{
      //     this.$router.push({ path: `/login`})
      //   }
      //   return
      // }

      if (!this.buyStatus || this.isadd || !this.saleSkuQuantity || this.isoff) {
        return;
      }

      this.isadd = true;
      var collageType = !this.isShop && this.goodsDetail.itemPintuanInfoVo ? this.type : "shop";
      this.$emit("confirmSpec", this.selectAttr, this.selectAttrId, this.payNum, collageType);
      setTimeout(function () {
        _this.isadd = false;
      }, 100);
    },
    okBuy: function okBuy() {
      var _this2 = this;

      if (!this.buyStatus || !this.saleSkuQuantity || this.isoff) {
        return;
      }

      this.$store.dispatch("user/checkLogin").then(function (res) {
        if (!_this2.isLogin) {
          if (_this2.$platform === "miniProgram") {
            var fullPath = _this2.$route.fullPath;
            var path = "/pages/detail/detail";

            _this2.$wx.miniProgram.redirectTo({
              url: "/pages/login/login?pagefrom=" + path + "&" + fullPath.split('?')[1]
            });
          } else {
            _this2.$router.push({
              path: "/login"
            });
          }

          return;
        }
      });

      if (!this.buyStatus || this.isadd || !this.saleSkuQuantity || this.isoff) {
        return;
      }

      this.isadd = true;
      this.$emit("confirmSpec", this.selectAttr, this.selectAttrId, this.payNum, 'newer');
      setTimeout(function () {
        _this2.isadd = false;
      }, 100);
    },
    limitHandle: function limitHandle(type) {
      console.log('limit', type);
      if (this.changeDisabled && this.saleSkuQuantity >= 1) return;

      if (type === "plus") {
        this.$toast("\u5E93\u5B58\u7D27\u5F20\uFF0C\u60A8\u6700\u591A\u53EF\u8D2D\u4E70".concat(this.saleSkuQuantity, "\u4EF6\u5546\u54C1"));
      }
    },
    changeNum: function changeNum(value) {
      this.$emit("changeNum", value);
    },
    updateNum: function () {
      var _updateNum = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(cartId, quantity) {
        var reqData, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reqData = {
                  params: {
                    cartId: cartId,
                    quantity: quantity
                  }
                };
                _context.next = 3;
                return this.$service.getShopCarAddDecrease(reqData);

              case 3:
                res = _context.sent;

                if (res && res.status == 200) {
                  this.getShopCarList();
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateNum(_x, _x2) {
        return _updateNum.apply(this, arguments);
      }

      return updateNum;
    }(),
    setDefault: function setDefault() {
      var _this3 = this;

      this.spuData.forEach(function (spu) {
        spu.attributeValues.forEach(function (attr) {
          if (_this3.defaultAttr.indexOf(attr.saleAttributeValueId) > -1) {
            attr.active = true;
          }
        });
      });
      this.setDisabled(this.defaultAttr[0], this.spuAttrs[0].saleSpuAttributeId);
    },
    attrHandle: function attrHandle(attr) {
      if (attr.active || !attr.saleState || !this.isShop && !attr.pintuanFlg) {
        return;
      }

      this.packAttr.forEach(function (spu) {
        spu.active = false;
      });
      attr.active = true;
      this.$emit("changeSku", attr.itemId); // this.getselectId()
      // this.spuData = JSON.parse(JSON.stringify(this.spuData))
      // this.setDisabled(attr.saleAttributeValueId,attr.saleSpuAttributeId)
    },
    getselectId: function getselectId() {
      this.isoff = false;
      var selectAttrIds = [];
      this.spuData.forEach(function (spu) {
        spu.attributeValues.forEach(function (attr) {
          if (attr.active) {
            selectAttrIds.push(attr.saleAttributeValueId);
          }
        });
      });
      var res = this.skuAttrs.filter(function (item) {
        return JSON.stringify(item.attrValues.sort()) === JSON.stringify(selectAttrIds.sort());
      });

      if (res.length) {
        this.selectAttrId = res[0].saleSkuId;
        this.$emit("changeSku", this.selectAttrId);
      } else {
        this.isoff = true; // this.saleSkuQuantity = 0;

        this.$emit("changeSku", "nosku");
      }
    },
    flatten: function flatten(arr) {
      var _this4 = this;

      return arr.reduce(function (prev, cur) {
        return prev.concat(Array.isArray(cur) ? _this4.flatten(cur) : cur);
      }, []);
    },
    setDisabled: function setDisabled(id, spuId) {
      var _this5 = this;

      if (this.spuAttrs.length === 1) {
        var filterData = this.skuAttrs.map(function (item) {
          return item.attrValues[0];
        });
        this.spuData.forEach(function (spu) {
          spu.attributeValues.forEach(function (attr) {
            if (filterData.indexOf(attr.saleAttributeValueId) < 0) {
              attr.disable = true;
            } else {
              attr.disable = false;
            }
          });
        });
        return;
      }

      var filterArr = [];
      this.skuAttrs.forEach(function (sku) {
        _this5.selectId.forEach(function (item) {
          if (sku.attrValues.indexOf(item) > -1) {
            filterArr.push(sku.attrValues);
          }
        });
      });
      var flatArr = this.flatten(filterArr);

      var ableArr = _toConsumableArray(new Set(flatArr));

      this.spuData.forEach(function (spu) {
        spu.attributeValues.forEach(function (attr) {
          if (ableArr.indexOf(attr.saleAttributeValueId) < 0) {
            attr.disable = true;
          } else {
            attr.disable = false;
          }
        });
      });
    }
  }
};